export default "__VITE_ASSET__cc5809ee__"